import Datastore from "./Datastore";

export default class LocalDatastore implements Datastore {
    private dictionary: any;

    constructor(dictionary: any) {
        this.dictionary = dictionary; 
    }
    getDict(name: string): any {
        return this.dictionary[name];
    }

    storeDict(name: string, dict: any): void {
        this.dictionary[name] = dict;
    }
}